/** Thai banks, card issuers and wallets with a known logo. */
export var ThaiBank;
(function (ThaiBank) {
    ThaiBank["Kbank"] = "KBANK";
    ThaiBank["Scb"] = "SCB";
    ThaiBank["Ktb"] = "KTB";
    ThaiBank["Ktc"] = "KTC";
    ThaiBank["Bbl"] = "BBL";
    ThaiBank["Bay"] = "BAY";
    ThaiBank["Ttb"] = "TTB";
    ThaiBank["Uob"] = "UOB";
    ThaiBank["Gsb"] = "GSB";
    ThaiBank["Ghb"] = "GHB";
    ThaiBank["Baac"] = "BAAC";
    ThaiBank["Cimb"] = "CIMB";
    ThaiBank["Citi"] = "CITI";
    ThaiBank["Hsbc"] = "HSBC";
    ThaiBank["Ibank"] = "IBANK";
    ThaiBank["Icbc"] = "ICBC";
    ThaiBank["Kkp"] = "KKP";
    ThaiBank["Lhb"] = "LHB";
    ThaiBank["Tcrb"] = "TCRB";
    ThaiBank["Tisco"] = "TISCO";
    ThaiBank["TrueMoney"] = "TRUEMONEY";
    ThaiBank["PromptPay"] = "PROMPTPAY";
    /** The user chose no logo; never auto-detected over. */
    ThaiBank["None"] = "NONE";
})(ThaiBank || (ThaiBank = {}));
//# sourceMappingURL=thai-bank.enum.js.map